import { createSelector } from 'reselect'
import { selectCurrentTicketId } from 'selectors/tickets/current/selectCurrentTicketId'
import { selectPreferences } from 'ducks/currentUser/selectors/preferences/selectPreferences'
import { emptyObj } from 'util/objects'

const selectUndoSend = state => state.undoSend || emptyObj

export const selectUndoSendSafe = state => {
  const { changesetId } = state.undoSend
  if (!changesetId) return emptyObj
  return state.undoSend
}

export const selectSendingTicketId = state => state.undoSend.ticketId || null

// Backwards compatibility hotfix
export const selectSendingTicketIds = createSelector(
  selectSendingTicketId,
  id => [id]
)

export const selectCurrentTicketIsDelayed = createSelector(
  selectCurrentTicketId,
  selectSendingTicketId,
  (currentId, sendingId) => sendingId === currentId
)

export const selectCurrentUndoSendDelay = createSelector(
  selectPreferences,
  preferences => preferences.undo_send_delay || 0
)

export const selectIsUndoActive = createSelector(
  selectUndoSend,
  undo => undo.isActive
)

export const selectCurrentUndoData = createSelector(
  selectUndoSend,
  ({ ticketId, draftId, changesetId, status, draft }) => ({
    ticketId,
    draftId,
    changesetId,
    status,
    draft,
  })
)
